import Cookies from 'universal-cookie';
import { getCookieRootDomain } from './cookies';

export const AttributionKeys = {
  MediaSource: 'media_source',
  MediaStatus: 'media_status'
};

export const MediaStatusValues = {
  Organic: 'Organic',
  NonOrganic: 'Non-organic'
};

const AttributionCookiesExpirationDays = 30;
const AttributionCookiesName = 'attribution';

const cookies = new Cookies();

const mergeAttributes = (existingAttributes, newAttributes) => ({
  ...existingAttributes,
  ...newAttributes
});

const ensureValidAttributionParams = (attributionParams) => {
  const lowercaseAttributionParams = {};

  Object.keys(attributionParams).forEach((key) => {
    const lowercaseKey = key.toLowerCase();
    lowercaseAttributionParams[lowercaseKey] = attributionParams[key];
  });

  return lowercaseAttributionParams;
};

export const getAttribution = () => cookies.get(AttributionCookiesName) || {};

export const getAttributionValue = (attributionKey) => getAttribution()[attributionKey];

const addWindowAttribution = (attributionParams) => {
  const currentAttribution = window.attribution || {};
  window.attribution = mergeAttributes(currentAttribution, attributionParams);
};

export const updateAttribution = (attributionParams) => {
  const validParams = ensureValidAttributionParams(attributionParams);
  addWindowAttribution(validParams);

  const currentCookiesAttribution = getAttribution();
  const updatedCookiesAttribution = mergeAttributes(currentCookiesAttribution, validParams);
  const cookieExpiration = currentCookiesAttribution?.expires;

  if (!cookieExpiration || validParams[AttributionKeys.MediaSource]) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + AttributionCookiesExpirationDays);
    cookies.set(AttributionCookiesName, updatedCookiesAttribution, {
      path: '/',
      expires: expirationDate,
      domain: getCookieRootDomain()
    });
  } else {
    cookies.set(AttributionCookiesName, updatedCookiesAttribution, {
      path: '/',
      domain: getCookieRootDomain()
    });
  }
};
